/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import add_comma from "../lib/add_comma";
import {
  MobileDateTimePicker,
  MobileDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState("");
  const [sdate, setSdate] = useState(null);
  const [regdate, setRegdate] = useState(null);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [pName, setPname] = useState("");
  const [amount, setAmount] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [method, setMethod] = useState("");
  const [pid, setPid] = useState("");
  const [tmcd, setTmcd] = useState("");
  const [fcid, setFcid] = useState("");
  const [useCash, setUseCash] = useState(0);
  const [useCoupon, setUseCoupon] = useState(0);

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    seq: seq,
    sdate: "",
    pid: "",
    amount: 0,
    method: "",
    tmcd: "",
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onChangeMethod = (e) => {
    setMethod(e.target.value);
    setData((state) => {
      return { ...state, method: e.target.value };
    });
  };

  const onSubmit = async () => {
    // pr('seq='+seq);
    // pr('tmcd='+tmcd);
    // pr('sdate='+sdate);
    // pr('pid='+pid);
    // pr('method='+method);
    // pr('amount='+amount);

    let result = await axios.post(
      configState.api + "/gympass_admin/purchase_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        tmcd: tmcd,
        sdate: sdate,
        pid: pid,
        method: method,
        amount: amount,
        fcid: fcid,
        regdate,
      },
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        },
      );
    }
  };

  // 회원찾기 팝업
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  // 상품찾기 팝업
  const onShowProductSearchClick = () => {
    setShowProductSearch(true);
  };

  const onHideProductSearchClick = () => {
    setShowProductSearch(false);
  };

  const onAfterProductSearchClick = (params) => {
    const { id, name, amount } = params;
    setPname(name);
    setSalePrice(amount);
    setAmount(amount);
    setPid(id);
  };

  const onAmountChange = (e) => {
    setAmount(e.target.value);
    setData((state) => {
      return { ...state, amount: e.target.value };
    });
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/purchase_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: data.seq,
      },
    );
    if (result.data.success === 1) {
      setTmcd(result.data.row.mcd);
      setSname(result.data.row.sName);
      setSdate(result.data.row.sdate);
      setPid(result.data.row.pid);
      setPname(result.data.row.item2);
      setSalePrice(result.data.row.sale_price);
      setAmount(result.data.row.amount);
      setMethod(result.data.row.method);
      setFcid(result.data.row.fcid);
      setUseCash(result.data.row.use_cash);
      setUseCoupon(result.data.row.use_coupon);
      setRegdate(result.data.row.regdate);

      // setData((state) => {
      //   return {
      //     ...state,
      //     pid: result.data.row.pid,
      //     method: result.data.row.method,
      //     tmcd: result.data.row.mcd,
      //     sdate: result.data.row.sdate,
      //     amount: result.data.row.amount,
      //   };
      // });
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/purchase_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            },
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Box>
      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      {/* 상품 찾기 */}
      <Dialog
        open={showProductSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>상품찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideProductSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ProductSearch
          login={login}
          onAfterProductSearchClick={onAfterProductSearchClick}
          onHideProductSearchClick={onHideProductSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        {/* 주문번호 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          주문번호 : {seq}
        </Box>
        <Box> 캐시할인 : {add_comma(useCash)}원</Box>
        <Box> 쿠폰할인 : {add_comma(useCoupon)}원</Box>

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sName}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 시작일 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDatePicker
              allowSameDateSelection={true}
              value={sdate}
              label="시작일"
              renderInput={(params) => <TextField size="small" {...params} />}
              onChange={(newDate) =>
                setSdate(moment(newDate).format("YYYY-MM-DD"))
              }
              inputFormat={"yyyy.MM.dd"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        {/* 상품명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="상품명"
            size="small"
            sx={{
              width: "280px",
            }}
            autoComplete="off"
            value={pName}
          ></TextField>
          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowProductSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 팜매가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="판매가"
            size="small"
            autoComplete="off"
            value={salePrice}
            sx={{ width: 180 }}
          ></TextField>
        </FormControl>

        {/* 구매가 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="amount"
            label="구매가"
            size="small"
            autoComplete="off"
            value={amount}
            sx={{ width: 180 }}
            onChange={(e) => setAmount(e.target.value)}
          ></TextField>
        </FormControl>

        {/* 결제방식 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>결제방식</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="method"
            onChange={onChangeMethod}
            value={method}
          >
            <FormControlLabel
              value="5"
              control={<Radio />}
              label="카드(현장)"
            />
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="카드(온라인)"
            />
            <FormControlLabel
              value="6"
              control={<Radio />}
              label="현금(현장)"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="현급(계좌)"
            />
            <FormControlLabel value="9" control={<Radio />} label="무료" />
          </RadioGroup>
        </FormControl>

        {/* 등록일 (구매일) */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDateTimePicker
              allowSameDateSelection={true}
              views={["year", "month", "day", "hours", "minutes", "seconds"]}
              value={regdate}
              label="등록일 (구매일)"
              renderInput={(params) => <TextField size="small" {...params} />}
              onChange={(dt) => {
                let dt_format = moment(dt).format("YYYY-MM-DD HH:mm:ss");
                setRegdate(dt_format);
              }}
              inputFormat={"yyyy.MM.dd hh:mm:ss"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          {(login.level === "500" || login.level === "100") && (
            <Button variant="contained" onClick={onSubmit}>
              수정완료
            </Button>
          )}

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            닫기
          </Button>

          {(login.level === "500" || login.level === "100") && (
            <Button
              variant="contained"
              color="warning"
              css={css`
                margin-left: 10px;
              `}
              onClick={onDeleteClick}
            >
              삭제
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;

// ======================= //
// 즐겨찾는 센터
// ======================= //
function FcenterSelect(props) {
  const { fcid, setFcid } = props;
  const [rows, setRows] = useState([]);
  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/center_list",
    );
    setRows(result.data);
  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <FormControl size="small" sx={{ width: 280 }}>
      <InputLabel>즐겨 찾는 센터</InputLabel>
      <Select
        onChange={(e) => {
          setFcid(e.target.value);
        }}
        value={fcid}
      >
        {rows.map((item, index) => {
          return (
            <MenuItem key={index} value={item.cid}>
              {item.center}:{item.location}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
